import { makeAutoObservable } from 'mobx';

import { TProfile } from './types';

export class ProfileStore {
  public profile: TProfile = {
    accountStatus: 1,
    emailStatus: 0,
    id: 0,
    login: '',
    phone: '',
    phoneStatus: 1,
  };

  public webpushPublicKey = '';

  constructor() {
    makeAutoObservable(this);
  }

  setUserData(profile: { user: TProfile; webpushPublicKey: string }) {
    this.profile = profile.user;
    this.webpushPublicKey = profile.webpushPublicKey;
  }
}
